import React from "react";
import {useRevalidator, useRouteLoaderData} from "react-router-dom";
import translate from "../../../../translate";
import {Column, ColumnGrid} from "../../ui/spectre/grid";
import GroupInvite from "./groupInvite";
import API from "../../../../api/api";
import {LinkButton} from "../../ui/spectre/buttons";
import {Icon} from "../../ui/spectre/icon";

export default function GroupInvites() {
    /**
     * @type groupDataType
     */
    const groupData = useRouteLoaderData('group');
    const revalidator = useRevalidator();

    if(!groupData.ownPermissions.SeeInvites) {
        return <div className={'bg-error p-1'}>{translate('error/groups/no_access')}</div>;
    }

    async function onDelete(id) {
        await API.delete('groups/invites/delete', {inviteId: id, groupId: groupData.id});
        revalidator.revalidate();
    }

    return <div>
        <LinkButton href={'./create'}>
            <div className={'d-inline-block pr-2'}><Icon type={'plus'} /></div>
            {translate('page/group/invites/create/pagetitle')}
        </LinkButton>

        <div className={'mt-2'}>
            <ColumnGrid size={'md'}>
                <Column sizes={[3]}><div className={'defaultTableHeader'}>{translate('page/group/invites/role')}</div></Column>
                <Column sizes={[3]}><div className={'defaultTableHeader'}>{translate('page/group/invites/link')}</div></Column>
                <Column sizes={[2]}><div className={'defaultTableHeader'}>{translate('page/group/invites/created_at')}</div></Column>
                <Column sizes={[2]}><div className={'defaultTableHeader'}>{translate('page/group/invites/created_by')}</div></Column>
                <Column sizes={[2]}><div className={'defaultTableHeader'}>{translate('page/group/invites/actions')}</div></Column>

                {Object.values(groupData.invites).map(invite => <GroupInvite key={invite.id} invite={invite} onDelete={onDelete.bind(null, invite.id)}></GroupInvite>)}
            </ColumnGrid>
        </div>
    </div>
}
